import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { ButtonList, NumberDisplayList, ProgressCircle } from "../..";
import { colors, css, Units, useUnitsComponent } from "../../../Styles";
import { EsfLocation } from "../../../Services/Agrisys_GqlDataCaller/WalkThroughDataCalls/getEsfStructureCall";
import StationCard from "../Station/stationCard";

interface sectionModal_Props {
  activeSectionId?: number;
  onStationSelected?: (stationId: number) => void;
  stations: EsfLocation[];
}

export default function EsfSectionModal({activeSectionId, onStationSelected, stations }:sectionModal_Props) {
  const { t } = useTranslation()
  const getUnit = useUnitsComponent();
  const [currentFeedview, setCurrentFeedview] = useState<"ANIMALS" | "STATIONS">("STATIONS");
   const [selectedPenNo, setSelectedPenNo] = useState<number | null>(null);
  
  // #region | Header Content
  // ProgressCircle: Remaining Today TODO
  const RemainingToday: JSX.Element = useMemo(() => {
    return (
      <ProgressCircle
        animation
        header={t("feed.general.remainingToday", {defaultValue: "remaining today"})}
        total={0}
        progressed={0}
        unit={getUnit(Units.kG_grey)}
      />
    );
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [t])

  // NumberDisplayList: Currently in this section TODO
  const FeedCorrections: JSX.Element = useMemo(() => {
    return (
      <div style={{height: "170px", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", marginTop: "18px"}}>
        <NumberDisplayList
          units={[
            "Stations",
            "Animals",
          ]}
          values={[
            0,
            0
          ]}
          header={"Currently in this section"}
        />
      </div>
    )
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [t])

  // Seperator Line
  const seperatorLine = (
    <div style={{width: "650px", display: "flex", alignItems: "center", justifyContent: "center", margin: "20px auto"}}>
      <div style={{width: "600px", height: "2px", backgroundColor: colors.greyTertiary}}/>
    </div>
  );

  const StationClick = (stationId: number) => {
    if (onStationSelected) {
      onStationSelected(stationId);
    }
  }
  // #endregion

  // #region | Feed View State Router
  const FeedviewStateRouter = () => {
    switch (currentFeedview) {
      case "ANIMALS":
        return (
          <div style={{ }}>
            ANIMALS
          </div>
        );
      case "STATIONS":
        return (
          <div style={{ display: "flex", flexDirection: "column", gap: "20px", padding: "20px 0px 0px 0px"}}>
            {stations.map((station) => 
              <StationCard key={station.location_id} station={station} onClick={() => StationClick(station.location_id)}/>
            )}
          </div>
        );
      default:
        return null;
    }
  }
  // #endregion
  
  return (<>
    <div style={{ ...css.modalTop }}>
      {RemainingToday}
      {FeedCorrections}
    </div>
    {seperatorLine}
    <div style={{ display: "flex", justifyContent: "center", flexDirection: "column", alignItems: "center"}}>
      <ButtonList
        hasActiveLoad
        contents={[
          "Stations",
          "Animals",
        ]}
        onClick={(i) => {
          if (i === 0) {setCurrentFeedview("STATIONS")}
          if (i === 1) {setCurrentFeedview("ANIMALS")}
        }}
        overrides={{baseButton: { ...css.button_FitContent }}}
      />
      {FeedviewStateRouter()}
    </div>
  </>)
}